import { render, staticRenderFns } from "./disassemb_record.vue?vue&type=template&id=14a82615&scoped=true&"
import script from "./disassemb_record.vue?vue&type=script&lang=js&"
export * from "./disassemb_record.vue?vue&type=script&lang=js&"
import style0 from "./disassemb_record.vue?vue&type=style&index=0&id=14a82615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a82615",
  null
  
)

export default component.exports